<template>
  <div>
    <ShopSteps :step="1" />
    <section v-if="!userCartItemCount" id="cart-summary" class="mb-4">
      <div class="container">
        <div class="row">
          <div class="col-xl-8 mx-auto">
            <div class="shadow-sm bg-white p-4 rounded">
              <div class="text-center p-3">
                <i class="las la-frown la-3x opacity-60 mb-3"></i>
                <h3 class="h4 fw-700">{{ $t("您的购物车是空的") }}</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section v-else id="cart-summary" class="mb-4">
      <div class="container">
        <div class="row">
          <div class="col-xxl-8 col-xl-10 mx-auto">
            <div class="shadow-sm bg-white p-3 p-lg-4 rounded text-left">
              <template v-for="(item0, index0) in userCart">
                <div class="mb-4" :key="index0">
                  <div
                      class="row gutters-5 d-none d-lg-flex border-bottom mb-3 pb-3"
                  >
<!--                    <div class="col-md-5 fw-600">{{ $t("产品") }}</div>-->
                    <div class="col-md-5 fw-600">{{ $t(item0.name) }}</div>
                    <div class="col fw-600">{{ $t("价格") }}</div>
                    <div class="col fw-600">{{ $t("税") }}</div>
                    <div class="col fw-600">{{ $t("数量") }}</div>
                    <div class="col fw-600">{{ $t("小计") }}</div>
                    <div class="col-auto fw-600">{{ $t("移除") }}</div>
                  </div>
                  <ul class="list-group list-group-flush">
                    <li
                        v-for="(item, index) in item0.carts"
                        :key="index"
                        class="list-group-item px-0 px-lg-3"
                    >
                      <div class="row gutters-5">
                        <div class="col-lg-5 d-flex">
                        <span class="mr-2 ml-0">
                          <img
                              :src="
                              getFileViewUrl(item.goodsSpecPic || item.goodsPic)
                            "
                              alt
                              class="img-fit size-60px rounded"
                          />
                        </span>
                          <div>
                            <div class="fs-14 opacity-60">{{ $t(item.goodsName) }}</div>
                            <div class="fs-14 opacity-60 text-primary" v-if="isValidateSpec(item.goodsSpecName)">{{ item.goodsSpecName }}</div>
                          </div>
                        </div>

                        <div class="col-lg col-4 order-1 order-lg-0 my-3 my-lg-0">
                          <span class="opacity-60 fs-12 d-block d-lg-none">{{ $t("价格") }}</span>
                          <span class="fw-600 fs-16">{{ formatMoney(priceDiscount(item0, item)) }}</span>
                        </div>
                        <div class="col-lg col-4 order-2 order-lg-0 my-3 my-lg-0">
                        <span class="opacity-60 fs-12 d-block d-lg-none">{{
                            $t("税")
                          }}</span>
                          <span class="fw-600 fs-16">{{ formatMoney(0) }}</span>
                        </div>

                        <div class="col-lg col-6 order-4 order-lg-0">
                          <div
                              class="row no-gutters align-items-center aiz-plus-minus mr-2 ml-0"
                          >
                            <button
                                class="btn col-auto btn-icon btn-sm btn-circle btn-light"
                                type="button"
                                @click="
                              item.number > 1 && item.number--;
                              debounceUpdate(item);
                            "
                            >
                              <i class="las la-minus"></i>
                            </button>
                            <input
                                v-model="item.number"
                                class="col border-0 text-center flex-grow-1 fs-16 input-number"
                                max="999"
                                min="1"
                                placeholder="1"
                                type="number"
                            />
                            <button
                                class="btn col-auto btn-icon btn-sm btn-circle btn-light"
                                type="button"
                                @click="
                              item.number++;
                              debounceUpdate(item);
                            "
                            >
                              <i class="las la-plus"></i>
                            </button>
                          </div>
                        </div>
                        <div class="col-lg col-4 order-3 order-lg-0 my-3 my-lg-0">
                        <span class="opacity-60 fs-12 d-block d-lg-none">{{
                            $t("小计")
                          }}</span>
                          <span class="fw-600 fs-16 text-primary">{{
                              formatMoney(priceDiscount(item0, item) * item.number)
                            }}</span>
                        </div>
                        <div
                            class="col-lg-auto col-6 order-5 order-lg-0 text-right"
                        >
                          <a
                              class="btn btn-icon btn-sm btn-soft-primary btn-circle"
                              href="javascript:void(0)"
                              @click="removeFromCart(item.id)"
                          >
                            <i class="las la-trash"></i>
                          </a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </template>

              <div
                class="px-3 py-2 mb-4 border-top d-flex justify-content-between"
              >
                <span class="opacity-60 fs-15">{{ $t("总计") }}</span>
                <span class="fw-600 fs-17">{{ formatMoney(userCartTotalPrice) }}</span>
              </div>
              <div class="row align-items-center">
                <div
                  class="col-md-6 text-center text-md-left order-1 order-md-0"
                >
                  <router-link class="btn btn-link" to="/">
                    <i class="las la-arrow-left"></i>
                    {{ $t("返回商店") }}
                  </router-link>
                </div>
                <div class="col-md-6 text-center text-md-right">
                  <a
                    class="btn btn-primary fw-600"
                    href="javascript:void(0)"
                    @click="jump('/user/checkout')"
                  > {{ $t("继续发货") }} </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { delCart, getCartList, updateById } from "@/api/user.cart";
import ShopSteps from "@/components/ShopSteps.vue";
import { debounce } from "@/utils/otherUtil";

export default {
  components: { ShopSteps },
  data() {
    return {
      debounceUpdate: null
    };
  },
  mounted() {
    this.debounceUpdate = debounce(this.updateNumber);
  },
  methods: {
    async updateNumber(cartItem) {
      await this.$store.dispatch("user/updateCartItem", cartItem);
    },
    priceDiscount(shop, goods) {
      if (!shop.isSeckillShop) return goods.price
      let buyDiscount = goods && goods.buyDiscount || 100;
      return goods && goods.price * buyDiscount / 100
    },
  }
};
</script>
